import { useSelector } from "react-redux"
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactBeforeSliderComponent from 'react-before-after-slider-component';
import { useState } from "react";
import CountUp from 'react-countup';
import { useRef } from "react";

const SuccessStories = () => {


    return (
        <>
            <div className="reviews-container">
                <div className="core-header">
                    <span>Our Real Impact</span>
                    <h1>Customer Success Stories</h1>
                    <p>See how our drone cleaning services have transformed the way businesses approach exterior cleaning.</p>

                </div>
                <div className="service-cards ">

                    <Link to={'/tank-terminal'} className="service-card flex-cards" data-aos="fade-up">
                        <img src="/assets/tank.jpeg" alt="A drone cleaning a commercial building" />
                        <h2>Tank Terminal - Sunshine, Louisiana</h2>
                        <p>With Flyby Shine’s drones, tank cleaning dropped from four men over four days to a two-person, one day job.</p></Link>

                    <Link to={'/defense-contractor'} className="service-card flex-cards" data-aos="fade-up" data-aos-delay="100">


                        <img src="/assets/federaldefensecontractor.png" alt="A drone cleaning a multi story building" />
                        <h2>Federal Defense Contractor Facility - Confidential Location</h2>
                        <p>A high-security defense plant had one shutdown day for exterior cleaning, we rapid deployed drones to get it done with zero disruption.</p>

                    </Link>
                    <Link to={'/state-agency'} className="service-card flex-cards" data-aos="fade-up" data-aos-delay="100">


                        <img src="/assets/stateagencybuilding.jpeg" alt="A drone cleaning a multi story building" />
                        <h2>State Agency Building - Jackson, Ms</h2>
                        <p>Our two-man drone crew cleaned the Jackson state agency's windows in four pre-dawn hours, replacing a two-week, damage-prone lift job and saving time.</p>

                    </Link>
                </div>

            </div>


        </>
    );
}

export default SuccessStories